import React from 'react';

import CustomIcon from 'components/common/CustomIcon';
import { notEmpty } from 'utils/ramdaAdditions';

export const PersonPhone = ({ phone }) => notEmpty(phone) ? (
    <dl className="dl-horizontal">
        { phone.map((phone, index) => (
            <dd key={index}>
                <CustomIcon type='phone-lg' /> <a href={phone.href}>{phone.text}</a>
                <small className="m-l-5">{phone.comment}</small>
            </dd>
        ))}
    </dl>
) : null;
